module.exports = __webpack_public_path__ + "img/locked.9b7372c1.svg";